module.exports = __webpack_public_path__ + "img/zoushi.f1dc37a6.png";